export const CATEGORY_WRAPPER_WIDTH = 352;
export const LIVE_COMPONENT_CATEGORY_CONTENT = 304;
export const SECTION_HEADER_TOOLTIP_MARGIN = 5;
